import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { PoaEdisService } from 'src/app/services/poa-edis.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-poa-edis',
  templateUrl: './poa-edis.component.html',
  styleUrls: ['./poa-edis.component.scss']
})
export class PoaEdisComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  tpingenerateurl: any = environment.GenerateTPIN_URL
  verifydis: any = environment.VerifyDIS_URL
  trndtls: any;
  version: any;
  dpId: any;
  reqId: any;
  G_SubBrokerId: any;
  G_LoginId: any;
  G_UserType: any

  constructor(private poaedis: PoaEdisService,
    private bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private http: HttpClient,
    private Loader: CustomLoaderService,
    private EncrdecrService: EncrdecrService
  ) {

  }
  ngOnInit(): void {
    if (sessionStorage.getItem("F44sGAGh2xwkpUL") != null) {
      //Session_SubBrokerId
      this.G_SubBrokerId = this.G_LoginId = this.EncrdecrService.getDecr(
        sessionStorage.getItem("F44sGAGh2xwkpUL")
      ); //Session_SubBrokerId
      this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem("L2D3506kIHSk3E0")));
    }
    this.CallVerifyDISAPI();
  }
  ngAfterViewInit(): void {

  }

  CallVerifyDISAPI() {
    this.Loader.show();
    var json = {
      //For thirdParty Journey Logs
      clientCode: localStorage.getItem('P9qFGsc4XEmEdiwjAs6Cvg=='), // Client Code
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem("L2D3506kIHSk3E0")),// User type
      initiatedBy: this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL")), // UserId
      //For thirdParty Journey Logs
      ReturnURL: window.location.href

    }
    var requestBody = JSON.stringify(json);
    this.poaedis.getVerifyDISData(requestBody).subscribe((data) => {
      console.log("Response data:", data.ArrayOfResponse[0]);
      if (data.ArrayOfResponse[0]) {
        this.trndtls = data.ArrayOfResponse[0].TransDtls;
        this.version = data.ArrayOfResponse[0].Version;
        this.reqId = data.ArrayOfResponse[0].ReqId;
        this.dpId = data.ArrayOfResponse[0].DPId;
        this.Loader.hide()
      }
      else {
        this.Loader.hide()
      }
    })
  }
  ProceedTPIN() {
    window.location.href = this.tpingenerateurl;
  }
  CloseMainModal() {
    this.bsModalRef.hide();
    this.Loader.show();
    let date = new Date();
    let rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.G_LoginId;

    var json = {
      //For thirdParty Journey Logs
      clientCode: localStorage.getItem('P9qFGsc4XEmEdiwjAs6Cvg=='), // Client Code
      userType: this.G_UserType,// User type
      initiatedBy: this.G_LoginId, // UserId
      rid: rid,
      jid: this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
      //For thirdParty Journey Logs
      reqId: this.reqId

    }
    var requestBody = JSON.stringify(json);

    this.poaedis.deleteTransdetails(requestBody).subscribe((data) => {
      console.log("Response data:", data);
        this.Loader.hide()
        location.reload();
    })
  }
  // This method will be called when the button is clicked
  redirectToSubmit() {
    // Submitting the form by triggering ngSubmit manually
    const form = document.getElementById('postForm') as HTMLFormElement;
    console.log("Form Values",form);
    
    form.submit();
  }

  // Form submission method (You can customize it further)
  onSubmit(form: any) {
    // You can handle any form logic here if needed
    console.log('Form submitted!', form);
  }
}

